//#region IMPORT
import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
/** Services Import */
/** Components */
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import Global from '../../../Services/Common/Global';
import Commons from '../../../Services/Common/Common';
import { CommonActions } from '../../../Reducer/CommonReducer';
import { Loading } from '../../../Components/MUIs';
import M_TBG_BASIC from './M_TBG_BASIC';
import { NavBarInfoActions } from '../../../Reducer/NavBarInfoReducer';
//#endregion

function M_TBG_BASICF() {
  //#region 변수
  const { userInfo, lanInfo } = useSelector((state) => state.BaseInfo);
  const dispatch = useDispatch();
  const activeStep = useSelector((state) => state.common.activeStep);
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    type: 'info',
  });
  const [messages, setMessages] = useState([]);
  const [userCount, setUserCount] = useState(0);
  const [check, setCheck] = useState([]);
  const ws = useRef(null); // WebSocket 인스턴스를 useRef로 저장
  const tbmCdRef = useRef(null);
  const startTimeRef = useRef(null);
  //#endregion

  useEffect(() => {
    Init();
    // 스택형 뒤로가기로 변경
    dispatch(NavBarInfoActions.setType('titleBar'));
    dispatch(NavBarInfoActions.setTitleName('TBM'));
    dispatch(NavBarInfoActions.setBgColor('#F3F7F8'));

    let listener;
    if (Capacitor.isNativePlatform()) {
      listener = App.addListener('appStateChange', async (state) => {
        if (state.isActive) {
          // 앱이 포그라운드로 돌아옴
          // 웹소켓 연결 상태 확인
          if (!ws.current || ws.current.readyState !== WebSocket.OPEN) {
            console.log('웹소켓 연결이 끊어져 있음. 재연결 시도...');
            try {
              // 기존 연결 닫기
              if (ws.current) {
                ws.current.close();
              }
              // 새 연결 시도
              await OpenWebSocket();
              console.log('웹소켓 재연결 완료');
            } catch (error) {
              console.error('웹소켓 재연결 실패:', error);
              setSnackbar((prev) => ({
                ...prev,
                open: true,
                message:
                  '연결을 복구할 수 없습니다. 페이지를 새로고침해주세요.',
                type: 'error',
              }));
            }
          } else {
            console.log('웹소켓 연결 상태 정상');
            SearchLogic2();
          }
        } else {
          // 앱이 백그라운드로 감
        }
      });
    }

    return () => {
      if (ws.current) {
        ws.current.close(); // ✅ 언마운트 시 연결 닫기
      }
      if (listener) {
        listener.remove();
      }
    };
  }, [dispatch]);

  const Init = async () => {
    setLoading(true);

    try {
      await SearchLogic1();
    } catch (e) {
      console.log('Error: ', e);
      setSnackbar({
        ...snackbar,
        open: true,
        message: e.message,
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  //#region 조회
  // TBM_CD 조회
  const SearchLogic1 = async () => {
    setLoading(true);

    try {
      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_TBM_R1',
            _USER_ID: userInfo.userid,
            _AUTH_CD: Commons.EncryptAES(userInfo.authCd),
          },
        ]
      ).then((result) => {
        let data = result.data;

        if (data.length > 0) {
          if (data[0].type === 'Error') {
            throw new Error(data[0].message);
          } else {
            tbmCdRef.current = data[0].TBM_CD;
            OpenWebSocket();
          }
        }
      });
    } catch (e) {
      console.log(e);
      setSnackbar({
        ...snackbar,
        open: true,
        message: e.message,
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  };
  // tbmstatus 교육현황 조회
  const SearchLogic2 = async () => {
    setLoading(true);

    try {
      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_TBM_STATUS_R1',
            _TBM_CD: Commons.EncryptAES(tbmCdRef.current),
          },
        ]
      ).then((result) => {
        let data = result.data;

        if (data.length > 0) {
          if (data[0].type === 'Error') {
            throw new Error(data[0].message);
          } else {
            tbmCdRef.current = data[0].TBM_CD;
            startTimeRef.current = new Date(data[0].TBM_START_DATE);

            // status 조회 성공 시 해당 단계로 이동(진행중인 tbm이 있는 경우)
            dispatch(CommonActions.setActiveStep(data[0].M_STEP));
          }
        } else {
          // status 조회 실패 시 초기화(진행중인 tbm이 없는 경우)
          SaveLogic1(0, 0);
          dispatch(CommonActions.setActiveStep(0));
        }
      });
    } catch (e) {
      console.log(e);
      setSnackbar({
        ...snackbar,
        open: true,
        message: e.message,
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  };
  //#endregion

  //#region 저장
  // tbmstatus 교육현황 저장
  const SaveLogic1 = async (_eStep, _mStep) => {
    setLoading(true);
    let saveData = [];

    try {
      saveData.push({
        procedureName: 'SP_TBM_STATUS_U1',
        _TBM_CD: Commons.EncryptAES(tbmCdRef.current) || '', // TBM코드
        _E_STEP: Commons.EncryptAES(_eStep.toString()) || '', // 근로자 교육 페이지
        _M_STEP: Commons.EncryptAES(_mStep.toString()) || '', // 관리자 교육 페이지
        _USER_ID: userInfo.userid, // 참석자ID
      });

      if (saveData.length > 0) {
        await Commons.Axios(
          'post1',
          Global.base.useUrl + Global.urls.Execute.execute,
          saveData
        ).then(async (result) => {
          let data = result?.data[0];

          if (data.type === 'Error') {
            throw new Error(data.message);
          } else {
            // setSnackbar({
            //   open: true,
            //   type: "success",
            //   message: "저장되었습니다.",
            // });
            // setModalToggle1(true);
          }
        });
      }
    } catch (e) {
      console.log(e);
      setSnackbar({
        ...snackbar,
        open: true,
        message: e.message,
        type: 'error',
      });
    }
  };
  //#endregion

  //#region 나머지함수
  // 웹소켓 서버 연결
  const OpenWebSocket = async () => {
    // WebSocket 서버에 연결 (ws:// 또는 wss://)
    ws.current = new WebSocket(
      `${process.env.REACT_APP_WEB_SOCKET}?roomId=${
        tbmCdRef.current
      }&userId=${Commons.DecryptoAES(userInfo.userid)}`
    );

    // 연결 성공 시
    ws.current.onopen = () => {
      console.log('웹소켓 연결됨');
      SearchLogic2();
    };

    // 메시지 수신 시
    ws.current.onmessage = (event) => {
      const HandleText = (text) => {
        try {
          const data = JSON.parse(text);

          if (data.type === 'userCount') {
            // 현재 인원수
            setUserCount(data.count);
          } else if (data.type === 'message') {
            // 채팅
            setMessages((prev) => [...prev, data.content]);
          } else if (data.type === 'next') {
            // 다음단계
          } else if (data.type.includes('check')) {
            // 교육여부 체크

            setCheck((prev) => {
              if (
                !prev.some(
                  (item) => item.id === data.id && item.type === data.type
                )
              ) {
                return [...prev, data]; // id, type가 다르면 추가
              }
              return prev; // 이미 존재하면 그대로 prev 반환
            });
          }
        } catch (e) {
          console.warn('JSON 파싱 실패:', e);
          setMessages((prev) => [...prev, text]);
        }
      };

      // 1. 메시지가 Blob이라면
      if (event.data instanceof Blob) {
        const reader = new FileReader();
        reader.onload = () => {
          HandleText(reader.result);
        };
        reader.readAsText(event.data); // ← Blob을 문자열로 변환
      } else {
        // 2. 메시지가 문자열이라면
        HandleText(event.data);
      }
    };

    // 에러 처리
    ws.current.onerror = (error) => {
      console.error('WebSocket 오류:', error);
    };

    // 연결 종료 시
    ws.current.onclose = () => {
      console.log('웹소켓 연결 종료됨');
    };

    // 컴포넌트 언마운트 시 WebSocket 닫기
    return () => {
      ws.current.close();
    };
  };

  // 메시지 전송
  const SendMessage = (title) => {
    if (ws.current && title.trim() !== '') {
      ws.current.send(title);
    }
  };

  const ActiveButton = (_data) => {
    if (ws.current && ws.current.readyState === WebSocket.OPEN) {
      ws.current.send(JSON.stringify(_data));
    } else {
      console.warn('웹소켓이 아직 연결되지 않았습니다.');
      setSnackbar({
        open: true,
        message: '웹소켓 연결 중입니다. 잠시 후 다시 시도해 주세요.',
        type: 'warning',
      });
    }
  };
  //#endregion
  const TbmEnd = () => {
    dispatch(CommonActions.setActiveStep(0)); // 홈으로 이동하기 때문에 0
    ws.current.close();
  };

  return (
    <div className="wrap">
      <M_TBG_BASIC
        // 변수
        activeStep={activeStep}
        userInfo={userInfo}
        lanList={lanInfo}
        userCount={userCount}
        setUserCount={setUserCount}
        check={check}
        setCheck={setCheck}
        tbmCdRef={tbmCdRef}
        startTimeRef={startTimeRef}
        // 함수
        ActiveButton={ActiveButton}
        SendMessage={SendMessage}
        TbmEnd={TbmEnd}
      />
      <Loading open={loading} />
    </div>
  );
}

export default M_TBG_BASICF;
